export default __webpack_public_path__ + "static/media/p3.a0d63c84.png";